import React from 'react'
import "./SubStyle.css"

const Soft_Rota = () => {
  return (
     <section className="OurServices">
     <h1 className="OurServices-title">Total Care Rota</h1>
      <p className="OurServices-pera">Simplify workforce scheduling with our intelligent rota management solution. Total Care Rota helps care providers efficiently manage staff shifts, improve coverage, reduce administrative workload, and ensure the right people are in the right place at the right time.</p>
         <div className="btn-container">
        <button className="OurServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default Soft_Rota
